type Listener = () => void;

let isMismatched = false;
const listeners = new Set<Listener>();

/**
 * Latches permanently once fired — a stale tab's first GRAPHQL_VALIDATION_FAILED
 * error routinely arrives before any UI subscribes, so replaying the latched
 * state to late subscribers (rather than firing a one-shot event) is what lets
 * the signal still reach the user.
 */
export function markSchemaMismatch(): void {
  if (isMismatched) {
    return;
  }
  isMismatched = true;
  listeners.forEach((listener) => listener());
}

/** Fires immediately if the mismatch already latched; otherwise waits for it. */
export function subscribeToSchemaMismatch(listener: Listener): () => void {
  if (isMismatched) {
    listener();
    return () => {};
  }
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Synchronous snapshot for `useSyncExternalStore`'s `getSnapshot`. */
export function isSchemaMismatched(): boolean {
  return isMismatched;
}
